// Client mirror of the curated reading lists (backend source of truth:
// backend/app/services/gamification_service.py COLLECTIONS — keep title_keys
// in sync, INCLUDING their order, when editing either side). Used to group the
// classics shelf into playlist rows on the dashboard; the badge/rank logic
// stays server-side. Keys are ordered easy -> hard so each shelf reads as an
// aspirational climb (listKeyRank sorts books by first matched key).

export const MIN_PLAYLIST_ROW_BOOKS = 4;

export const READING_LISTS = [
  {
    id: 'gothic',
    title: 'Gothic Literature',
    blurb: 'Vampires, doubles, and haunted moors. The books that invented dark.',
    title_keys: [
      'monkey', 'carmilla', 'jekyll', 'usher', 'tell-tale heart',
      'turn of the screw', 'dracula', 'wuthering', 'frankenstein'
    ]
  },
  {
    id: 'casebook',
    title: 'Detective Fiction',
    blurb: 'Follow the clues through the fog of Victorian London.',
    title_keys: [
      'scandal in bohemia', 'sign of the four', 'sherlock', 'holmes',
      'baskervilles', 'rue morgue', 'moonstone'
    ]
  },
  {
    id: 'austen',
    title: 'The Novel of Manners',
    blurb: "Austen's drawing rooms: wit, matchmaking, and social chess played for keeps.",
    title_keys: [
      'northanger', 'persuasion', 'sense and sensibility',
      'pride & prejudice', 'pride and prejudice', 'emma', 'mansfield park'
    ]
  },
  {
    id: 'young_ears',
    title: 'The Golden Age of Wonder',
    blurb: 'Alice, Pan, Mowgli, and the riverbank. The stories every other story borrows from.',
    title_keys: [
      'peter pan', 'alice', 'wonderland', 'wind in the willows',
      'jungle book', 'treasure island', 'secret garden', 'wizard of oz'
    ]
  },
  {
    id: 'russian',
    title: 'Russian Existentialism',
    blurb: 'Guilt, God, and one very bad idea. The deepest books ever written.',
    title_keys: [
      'notes from underground', 'fathers and sons', 'dead souls',
      'crime and punishment', 'the idiot', 'karamazov'
    ]
  },
  {
    id: 'myth_epic',
    title: 'Mythology & Epic',
    blurb: 'Gods, monsters, and the long way home. Where Western storytelling begins.',
    title_keys: [
      'bulfinch', 'gilgamesh', 'odyssey', 'iliad',
      'aeneid', 'beowulf', 'metamorphoses', 'paradise lost'
    ]
  },
  {
    id: 'american',
    title: 'The American Novel',
    blurb: 'Green lights, white whales, and the price of the dream.',
    title_keys: [
      'call of the wild', 'huckleberry', 'scarlet letter', 'gatsby',
      'walden', 'leaves of grass', 'moby'
    ]
  },
  {
    id: 'pretenders',
    title: 'Books People Pretend to Have Read',
    blurb: "Everyone quotes them. Almost nobody finishes them. You're about to.",
    title_keys: [
      'gatsby', 'dracula', 'wuthering', 'crime and punishment',
      'odyssey', 'moby', 'war and peace', 'don quixote'
    ]
  },
  {
    id: 'wisdom',
    title: 'Stoic Philosophy',
    blurb: 'Old ideas that still run the world, from emperors and slaves alike.',
    title_keys: [
      'art of war', 'meditations', 'marcus aurelius', 'tao te ching',
      'epictetus', 'enchiridion', 'zarathustra', 'beyond good and evil'
    ]
  },
  {
    id: 'new_worlds',
    title: 'Early Science Fiction',
    blurb: 'The books that invented the future, still ahead of their time.',
    title_keys: [
      'time machine', 'war of the worlds', 'invisible man', 'eighty days',
      'twenty thousand leagues', 'centre of the earth', 'center of the earth'
    ]
  }
];

const normalizeTitle = (value) => String(value || '').toLowerCase().split(/\s+/).join(' ');

export function listMatchesTitle(list, title) {
  const normalized = normalizeTitle(title);
  if (!normalized) return false;
  return list.title_keys.some((key) => normalized.includes(key));
}

// Aspirational sort key: the index of the first title_key a book matches.
// Keys are ordered easy -> hard, so sorting a shelf's books by this renders
// the ladder. Unmatched titles sort to the end.
export function listKeyRank(list, title) {
  const normalized = normalizeTitle(title);
  if (!normalized) return list.title_keys.length;
  const idx = list.title_keys.findIndex((key) => normalized.includes(key));
  return idx === -1 ? list.title_keys.length : idx;
}
